;(function (Wishlist, $) {
    var $wishlistBtn = $('.wishremove');
    var $wishlistCart = $('.cart');
    var $wishcount = $('.wishcount');
    var numProductTiles = $wishlistCart.length;
    var wishlist = localStorage.getItem('wishtems') || [];
    var wishcountall = localStorage.getItem('wishtemscount');

    

    $wishcount.html(wishcountall == null ? 0 : wishcountall);

    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('wishtems'));
    }
    var animateWishlist = function (e) {
        $(e).toggleClass('wishactive');
    };
    var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        //var wishcountvalue = localStorage.getItem('wishtemscount');
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1);
            var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp != null){
                var minus_val = -1;
                var wish_ct = Math.max(parseInt(wishcountp) + minus_val, 0);
                localStorage.setItem('wishtemscount', wish_ct);
            }
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
            //var icon_length = $(self).find("span").length;
            if($(self).find("span").length != 0){
                $wishlistBtn.html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path><use xlink:href="#wish"></use></svg></span><span class="loadtowish wishanimated"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path><use xlink:href="#refresh"></use></svg></span><span class="wishirmv"><svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"/><use xlink:href="#icon-close"></use></svg></span>');
            }
            //var wishcountp_value = localStorage.getItem('wishtemscount');
            $wishcount.html(localStorage.getItem('wishtemscount'));
        }
        else {
            wishlist.push(productHandle);
            var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp == null){
                var plus_val = 1;
                var wish_ct = plus_val;
            }else{
            var plus_val = 1;
            var wish_ct = Math.max(parseInt(wishcountp) + plus_val, 0);
        }
            localStorage.setItem('wishtemscount',wish_ct);
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
            var icon_length = $(self).find("span").length;
            if(icon_length != 0){
                $wishlistBtn.html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path><use xlink:href="#wish"></use></svg></span><span class="loadtowish wishanimated"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path><use xlink:href="#refresh"></use></svg></span><span class="wishirmv"><svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"/><use xlink:href="#icon-close"></use></svg></span>');
            }
            var wishcountp_value = localStorage.getItem('wishtemscount');
            $wishcount.html(wishcountp_value);
        }
    };
    var activateWishItems = function () {
        $wishlistBtn.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('wishactive');
                var icon_length = $(this).find("span").length;
                if($(this).hasClass('wishactive')){
                    if(icon_length != 0){
                        $(this).html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path><use xlink:href="#wish"></use></svg></span><span class="loadtowish wishanimated"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path><use xlink:href="#refresh"></use></svg></span><span class="wishirmv"><svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"/><use xlink:href="#icon-close"></use></svg></span>');
                    }
                }else{
                    if(icon_length != 0){
                        $(this).html('<span class="addtowish"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path><use xlink:href="#wish"></use></svg></span><span class="loadtowish wishanimated"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path><use xlink:href="#refresh"></use></svg></span><span class="wishirmv"><svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"/><use xlink:href="#icon-close"></use></svg></span>');
                    }
                }
            }
        });
    };
    var displayWishItems = function () {
        $wishlistCart.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                $(this).remove();
                numProductTiles--;
            }
        });
    };
    var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayWishItems();
            $('.wishloader').fadeOut(2000, function () {
                $('.mainwish .wishlist-hero').addClass('wishvisible');
                //$('.wishlist-hero').addClass('wishvisible');
                if (numProductTiles == 0) {
                    $('.wishempty').addClass('wishvisible');
                    $('.mainwish').hide();
                } else {
                    $('.wishempty').hide();
                }
            });
        }
    };
    var bindUIActions = function () {
        $wishlistBtn.click(function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
        });
    };
    Wishlist.init = function () {
        bindUIActions();
        activateWishItems();
        loadWishlist();
    };
    $("#wishcall").click(function(){
        //var raw = localStorage.getItem('wishtems');
        //var length = raw.length;
        var length = localStorage.getItem('wishtems').length;
        //var i;
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        for ( var i=length-1; i>= 0; i--){
        var removeIndex = wishlist.indexOf(productHandle);
        wishlist.splice(removeIndex, 1);
        var wishcountp = localStorage.getItem('wishtemscount');
            if(wishcountp != null){
                var wish_ct = Math.max(parseInt(0), 0);
                localStorage.setItem('wishtemscount', wish_ct);
            }
            localStorage.setItem('wishtems', JSON.stringify(wishlist));
        }
        location.reload(true);
    });
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
function reloadPage(){
    location.reload(true);
}